import type { RootState } from "@/lib/types/state";

/**
 * Selects the global loading state from the Redux store.
 *
 * @param state - The root Redux state
 * @returns true if the global loader is currently active, false otherwise
 */
export const selectIsGlobalLoading = (state: RootState): boolean => {
  return state?.loader?.isLoading ?? false;
};

/**
 * Selects whether a multi-part request is currently in progress.
 *
 * @param state - The root Redux state
 * @returns true if a multi-part request is active, false otherwise
 */
export const selectIsMultiPartRequest = (state: RootState): boolean => {
  return state?.loader?.isMultiPartRequest ?? false;
};

/**
 * Selects the complete loader state object.
 *
 * @param state - The root Redux state
 * @returns The loader state object containing isLoading and isMultiPartRequest
 */
export const selectLoaderState = (state: RootState) => {
  return state?.loader ?? { isLoading: false, isMultiPartRequest: false };
};
